<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Service Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.service_name')"
                v-model.trim="filterOptions.service_name"
              />
              <!-- End:: Service Name Input -->

              <!-- Start:: Provider Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.provider_name')"
                v-model.trim="filterOptions.provider_name"
              />
              <!-- End:: Provider Name Input -->

              <!-- Start:: Status Input -->
              <!-- <base-select-input
                col="4"
                :optionsList="request_statuses"
                :placeholder="$t('PLACEHOLDERS.request_status')"
                v-model="filterOptions.request_status"
              /> -->
              <!-- End:: Status Input -->

              <!-- Start:: Price Input -->
              <base-input
                col="4"
                type="number"
                :placeholder="$t('PLACEHOLDERS.suggested_price')"
                v-model.trim="filterOptions.price"
              />
              <!-- End:: Price Input -->

              <!-- Start:: From Date Input -->
              <base-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.from')"
                v-model.trim="filterOptions.from"
              />

              <!-- Start:: To Date Input -->
              <base-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.to')"
                v-model.trim="filterOptions.to"
              />
            </div>

            <div class="btns_wrapper">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.search") }}</span>
                </template>
                <span
                  class="submit_btn"
                  @click="submitFilterForm"
                  :disabled="isWaitingRequest"
                >
                  <i class="fal fa-search"></i>
                </span>
              </a-tooltip>

              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.rseet_search") }}</span>
                </template>
                <span
                  class="reset_btn"
                  :disabled="isWaitingRequest"
                  @click="resetFilter"
                >
                  <i class="fal fa-redo"></i>
                </span>
              </a-tooltip>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.servicesmanagement") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>

        <!-- Start:: Service Name -->
        <template v-slot:[`item.service_name`]="{ item }">
          <h6 class="text-danger" v-if="!item.service_name_ar && !item.service_name_en">
            {{ $t("TABLES.noData") }}
          </h6>
          <div v-else>
            <p><strong>{{ item.service_name_ar }}</strong></p>
            <p class="text-muted">{{ item.service_name_en }}</p>
          </div>
        </template>

        <!-- Start:: Provider Name -->
        <template v-slot:[`item.provider_name`]="{ item }">
          <h6 class="text-danger" v-if="!item.provider?.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.provider.name }}</h6>
        </template>

        <!-- Start:: Suggested Price -->
        <template v-slot:[`item.suggested_price`]="{ item }">
          <span>{{ item.price }} {{ item.currency || 'SAR' }}</span>
        </template>

        <!-- Start:: Status -->
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            text-color="white"
            small
          >
            {{ item.status }}
          </v-chip>
        </template>

        <!-- Start:: Created At -->
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at }}</span>
        </template>

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom" v-if="$can('additionalservices show', 'additionalservices')">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>

            <a-tooltip placement="bottom" v-if="$can('additionalservices updateprice', 'additionalservices')">
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>
              <button class="btn_edit" @click="editItem(item)">
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip>

            <!-- Approve Button -->
            <a-tooltip 
              placement="bottom" 
              v-if="item.status === 'pending_review' && $can('additionalservices activate', 'additionalservices')"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.approve") }}</span>
              </template>
              <button class="btn_approve" @click="approveItem(item)">
                <i class="fal fa-check"></i>
              </button>
            </a-tooltip>

            <!-- Reject Button -->
            <a-tooltip 
              placement="bottom" 
              v-if="item.status === 'pending_review' && $can('additionalservices activate', 'additionalservices')"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.reject") }}</span>
              </template>
              <button class="btn_reject" @click="selectRejectItem(item)">
                <i class="fal fa-times"></i>
              </button>
            </a-tooltip>
          </div>
        </template>

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Reject Modal -->
          <v-dialog v-model="dialogReject" max-width="500">
             <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToReject">
                {{
                  $t("TITLES.rejectAddService", {
                    name: itemToReject?.name || "هذا العنصر",
                  })
                }}
              </v-card-title>

              <form class="w-100">
                <base-input
                  col="12"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.reason')"
                  v-model.trim="rejectReason"
                  required
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="confirmRejectItem"
                  :disabled="!!!rejectReason || rejectReason?.length < 3"
                >
                  {{ $t("BUTTONS.reject") }}
                </v-btn>

                <v-btn
                  class="modal_cancel_btn"
                  @click="dialogReject = false"
                  >{{ $t("BUTTONS.cancel") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AllServicesManagement",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    request_statuses() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.pending"),
          value: "pending_review",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.accepted"),
          value: "available",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.rejected"),
          value: "rejected",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        service_name: null,
        provider_name: null,
        request_status: null,
        price: null,
        from: null,
        to: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Clients.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.service_name"),
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.provider_name"),
          value: "provider.name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.suggested_price"),
          value: "suggested_price",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.status"),
          value: "status_trans",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.model_date"),
          value: "created_at",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Clients.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data

      // Start:: Dialogs
      dialogReject: false,
      itemToReject: null,
      rejectReason: null,
      rejectionErrors: {},
      // End:: Dialogs
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
  },

  methods: {
    // Start:: Filter Methods
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/servicesmanagement/all", query: { page: 1 } });
      }
      this.setTableRows();
    },

    async resetFilter() {
      this.filterOptions.service_name = null;
      this.filterOptions.provider_name = null;
      this.filterOptions.request_status = null;
      this.filterOptions.price = null;
      this.filterOptions.from = null;
      this.filterOptions.to = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/servicesmanagement/all", query: { page: 1 } });
      }
      this.setTableRows();
    },

    // Start:: Table Methods
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "additional-services-requests",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.service_name,
            provider_name: this.filterOptions.provider_name,
            service_status: this.filterOptions.request_status?.value,
            price: this.filterOptions.price,
            from_date: this.filterOptions.from,
            to_date: this.filterOptions.to,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // Start:: Status Methods
    getStatusColor(status) {
      switch (status) {
        case 'pending_review':
          return 'orange';
        case 'accepted':
          return 'green';
        case 'rejected':
          return 'red';
        default:
          return 'grey';
      }
    },

    getStatusText(status) {
      switch (status) {
        case 'pending_review':
          return this.$t("PLACEHOLDERS.pending");
        case 'accepted':
          return this.$t("PLACEHOLDERS.accepted");
        case 'rejected':
          return this.$t("PLACEHOLDERS.rejected");
        default:
          return this.$t("PLACEHOLDERS.unknown");
      }
    },

    // Start:: CRUD Methods
    showItem(item) {
      this.$router.push({ path: `/servicesmanagement/show/${item.id}` });
    },

    editItem(item) {
      this.$router.push({ path: `/servicesmanagement/edit/${item.id}` });
    },

    async approveItem(item) {
      try {
        await this.$axios({
          method: "POST",
          url: `additional-services/${item.id}/change-status`,
          data: {
            status: "approved"
          },
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.approvedSuccessfully"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    selectRejectItem(item) {
      this.dialogReject = true;
      this.itemToReject = item;
      this.rejectReason = "";
      this.rejectionErrors = {};
    },

    async confirmRejectItem() {
      this.rejectionErrors = {};
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.$message.error(this.$t("MESSAGES.rejection_reason_required"));
        return;
      }

      try {
        await this.$axios({
          method: "POST",
          url: `additional-services/${this.itemToReject.id}/change-status`,
          data: {
            status: "rejected",
            reason: this.rejectReason
          },
        });
        this.dialogReject = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.rejectedSuccessfully"));
      } catch (error) {
        this.dialogReject = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
  },
};
</script>

<style>
span.submit_btn {
  width: 45px;
  height: 45px;
  font-size: 16px;
  border-radius: 10px;
  color: var(--white_clr);
  transition: all 0.3s linear;
  background-color: #f6a513;
  display: flex;
  justify-content: center;
  align-items: center;
}

.price-tag {
  background-color: #28a745;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.btn_approve {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 0 2px;
  cursor: pointer;
}

.btn_reject {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 0 2px;
  cursor: pointer;
}
</style>
